import { BigWhitePass } from 'components/views/pages/bigwhitepass/index';

export default BigWhitePass;
